import PACKAGE_JSON from "../../../../package.json";

export const SYSTEM = {
  NAME: "Geslub Dashboard",
  DESCRIPTION:
    "Sistema de analisis descriptivo, analisis predictivos y representación grafica de datos Bel-Ray Ventec.",
  VERSION: PACKAGE_JSON.version,
};

const BASE_ROUTES = {
  APP: "/app",
  FRAME: "/frame",
};

export const ROUTES = {
  APP: BASE_ROUTES.APP,
  HOME: `${BASE_ROUTES.APP}/home`,
  PROJECTIONS: `${BASE_ROUTES.APP}/projections`,
  ANALYSIS: `${BASE_ROUTES.APP}/analysis`,
  FRAME_SAMPLE_ANALYSIS: `${BASE_ROUTES.FRAME}/sample_analysis`,
};
